import React, { useEffect, useState } from 'react'
import { PageObj } from '../Interfaces/TestCaseInterface';
import IconButton from '@mui/material/IconButton';
import ButtonGroup from '@mui/material/ButtonGroup';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import ListItem from '@mui/material/ListItem';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import DeleteIcon from '@mui/icons-material/Delete';
import './PageSelector.css'
import cloneDeep from 'lodash/cloneDeep';

export interface PageSelectorProps {
  page: PageObj,
  setTestPages: (pid: number, newPage: PageObj) => void,
  updatePageIx: (pid: number, adjustment: number) => void,
  deletePage: (pid: number) => void,
  activePagePid: number,
  setActivePagePid: React.Dispatch<React.SetStateAction<number>>,
  pageNames: Array<string>,
  pageTemplates: Record<string, Array<string>>,
  editable: boolean,
  saveCurrentPageBeforePageChange: (newPageId: number) => void
}

export const PageSelector = (props: PageSelectorProps) => {
  const [customPageName, setCustomPageName] = useState(false);

  const updateName = (e: string, custom: boolean) => {
    let newPageObj = cloneDeep(props.page); // clone page from props
    newPageObj.name = e;

    if (props.pageNames.length > 0 && e === "custom") {
      setCustomPageName(true);
    } else if (!custom) {
      setCustomPageName(false);
    }
    props.setTestPages(props.page.pid, newPageObj);
  } // updateName()

  useEffect(() => {
    if (props.pageNames.length > 0 && !props.pageNames.includes(props.page.name)) {
      setCustomPageName(true);
    } else {
      setCustomPageName(false);
    }
  }, [props.page.name])


  const changeActivePage = () => {
    if (props.editable) {
      // save current page to pages
      props.saveCurrentPageBeforePageChange(props.page.pid);
    }
    props.setActivePagePid(props.page.pid);
  }

  return (
    <ListItem secondaryAction={<Button onClick={changeActivePage}>
      {props.editable ? "Edit" : "View"}
    </Button>}>
      <Grid container>
        <Grid item xs={7}>
          {!props.editable ? <Typography variant='subtitle1'>{props.page.name}</Typography> : props.pageNames.length > 0 ?
            <TextField
              select
              fullWidth
              name="pageNameSelect"
              id="pageNameSelect"
              size='small'
              variant='standard'
              disabled={!props.editable}
              value={customPageName ? "custom" : props.page.name}
              onChange={(e) => updateName(e.target.value, false)}>
              {props.pageNames.map(page => <MenuItem key={page} value={page}>{page}</MenuItem>)}
              <MenuItem value={"custom"}>Custom</MenuItem>
            </TextField> :
            <TextField
              variant='filled'
              hiddenLabel
              value={props.page.name}
              disabled={!props.editable}
              onChange={(e) => updateName(e.target.value, false)} />}
          {customPageName && props.editable ?
            <TextField
              variant='filled'
              hiddenLabel
              value={props.page.name}
              disabled={!props.editable}
              onChange={(e) => updateName(e.target.value, true)}
            /> : <></>
          }
        </Grid>
        <Grid item xs={3}>
          <ButtonGroup size='small'>
            <IconButton disabled={!props.editable} className='orderingButton' color='secondary' size="small" onClick={(e) => props.updatePageIx(props.page.pid, -1)}><ArrowUpwardIcon /></IconButton>
            <IconButton disabled={!props.editable} className='orderingButton' color='secondary' size="small" onClick={(e) => props.updatePageIx(props.page.pid, 1)}><ArrowDownwardIcon /></IconButton>
            <IconButton disabled={!props.editable} className='orderingButton' color='secondary' size="small" onClick={(e) => props.deletePage(props.page.pid)}><DeleteIcon /></IconButton>
          </ButtonGroup>
        </Grid>
      </Grid>
    </ListItem>
  ) // return
} // PageSelector() render fn


